import { useSessionStore } from '@/stores/session';
import styles from './StatusDots.module.css';

/**
 * Per-block status dots row — visual at-a-glance summary of generation state.
 *
 * Mirrors vanilla `renderStatusDots()` (legacy/index.html:4658-4665) and the
 * `ttsStatusDots` mount point inside the bottom bar next to `ttsDurationInfo`
 * (legacy/index.html:2458). Vanilla CSS lives at legacy/index.html:1798-1807.
 *
 * Vanilla per-dot semantics (only two states — see legacy 4661-4664):
 *   - default → empty / no favorite picked yet → background `var(--border2)`
 *   - .done   → has favorite (`b.favIdx >= 0 && b.takes[b.favIdx]`) → #15D514
 *
 * Vanilla does NOT emphasize the active block, does NOT make dots clickable,
 * does NOT use Phosphor icons — pure CSS spans only. We mirror that here.
 *
 * Empty state (zero blocks) → render nothing (no empty wrapper).
 */
export function StatusDots() {
  const currentAssetIdx = useSessionStore((s) => s.currentAssetIdx);
  const assetBlocks = useSessionStore((s) => s.assetBlocks);
  const blocks = assetBlocks[currentAssetIdx] ?? [];

  if (blocks.length === 0) return null;

  return (
    <div className={styles.row} aria-hidden="true">
      {blocks.map((b, i) => {
        // Same condition as vanilla legacy 4662.
        const hasFav = b.favIdx >= 0 && !!b.takes[b.favIdx];
        return (
          <span
            key={i}
            className={`${styles.dot} ${hasFav ? styles.done : ''}`}
            title={`Block ${i + 1}: ${hasFav ? 'favorite set' : 'no favorite yet'}`}
          />
        );
      })}
    </div>
  );
}
